
import { useSelector } from 'react-redux';
import { getSettings } from 'redux/slices/settingSlice';

export const useSettingValue = (key) => {
    const settings = useSelector(getSettings)
    return settings?.find(({ settingKey }) => settingKey === key)?.settingValue;
};